export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20diverse%20fashion%20and%20lifestyle%20products%20arranged%20in%20organized%20grid%20pattern%20on%20light%20gray%20textured%20surface%2C%20sneakers%20bags%20accessories%20watches%2C%20bright%20neutral%20studio%20lighting%2C%20clean%20editorial%20catalog%20photography%2C%20bird%20eye%20view%2C%20minimalist%20organized%20composition&width=1800&height=900&seq=hero-hipobuy-v2&orientation=landscape"
          alt="Hipobuy Spreadsheet product research and shopping guide"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <i className="ri-sparkling-2-line text-accent-400 text-sm"></i>
            <span className="text-xs md:text-sm text-background-50 font-medium">
              #1 Spreadsheet Resource Hub for 2026
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4 md:mb-6">
            Hipobuy Spreadsheet
            <span className="block text-accent-300 font-heading italic font-semibold">
              The Ultimate Product Research &amp; Shopping Guide
            </span>
          </h1>

          <p className="text-sm md:text-base text-background-200 max-w-lg mb-8 leading-relaxed">
            Discover thousands of organized product finds, shopping resources, comparison guides, and expert tips with the Hipobuy Spreadsheet. Your complete product discovery platform for smarter, faster shopping decisions.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="#categories"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-sm hover:bg-primary-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Explore Categories
              <i className="ri-arrow-down-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border-2 border-background-50 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Visit Main Platform
              <i className="ri-external-link-line"></i>
            </a>
          </div>

          <div className="flex flex-wrap gap-4 md:gap-6 mt-8">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-accent-400 text-sm"></i>
              <span className="text-xs text-background-200">Updated Product Resources</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-accent-400 text-sm"></i>
              <span className="text-xs text-background-200">Organized Shopping Database</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-accent-400 text-sm"></i>
              <span className="text-xs text-background-200">Beginner Friendly Guides</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-accent-400 text-sm"></i>
              <span className="text-xs text-background-200">Secure Shopping Information</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}